export const FormatWeekdayTime = (date: string): string => {
  const { format } = new Intl.DateTimeFormat('en', { weekday: 'short', hour: '2-digit', minute: '2-digit' });
  return format(new Date(date));
};

export const FormatFullDateTime = (date: string): string => {
  const dateFormat = new Intl.DateTimeFormat('en', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });

  const timeFormat = new Intl.DateTimeFormat('en', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });

  return `${dateFormat.format(new Date(date))} ${timeFormat.format(new Date(date))}`;
};
